/**
 * KRADFILE เขียนชิ้นส่วนบางตัวด้วย codepoint คนละตัวกับที่เราสอน
 *
 * เอกสารของ KRADFILE (https://www.edrdg.org/krad/kradinf.html) บอกไว้เอง:
 *   "Where the element alone is not in JIS X 0208, a kanji which contains
 *    the element is used instead"
 * และการแบ่งชิ้นส่วน "is based on what can be seen in typical kanji glyphs"
 * ไม่ใช่ระบบ radical แบบพจนานุกรม — เขาออกแบบมาให้ *ค้นหา* คันจิ ไม่ใช่ให้เรียน
 *
 * ผลคือ 氵 กลายเป็น 汁 · 扌 กลายเป็น 扎 · 八 กลายเป็น ハ (katakana)
 * ถ้าไม่แปลงกลับ ระบบจะคิดว่าเราไม่รู้จักชิ้นส่วนที่เรียนไปแล้ว
 * แล้วข้ามคันจิที่แตกได้ทั้งที่แตกได้จริง
 *
 * ทุกคู่ตรวจด้วยข้อมูลแล้ว ไม่ได้เดาจากรูป — เกณฑ์คือ KRADFILE ต้องไม่เคยใช้
 * ฝั่งขวาเลย และต้องไม่มีคันจิตัวไหนที่มีทั้งสองฝั่งพร้อมกัน (ถ้าเป็นคนละ
 * ชิ้นส่วนจริงย่อมต้องเจออยู่ด้วยกันบ้าง)
 *
 * ตัวอย่างที่ตกเกณฑ์: 个 ไม่ใช่ 人 — มี 46 คันจิที่มีทั้งคู่ (倹 剣 検)
 */
export const KRAD_ALIAS: ReadonlyMap<string, string> = new Map([
  ['ノ', '丿'], // ขีดเฉียง — katakana no
  ['ハ', '八'], // แปด — katakana ha
  ['艾', '艹'], // หญ้า
  ['汁', '氵'], // น้ำ (สามจุด)
  ['扎', '扌'], // มือ
  ['忙', '忄'], // ใจ
  ['阡', '阝'], // เนินเขา / เมือง
  ['刈', '刂'], // มีด
  ['杰', '灬'], // ไฟ (สี่จุด)
  ['込', '辶'], // เดินทาง
])

/** แปลงชิ้นส่วนจาก KRADFILE ให้เป็นรูปที่เราสอน */
export function canonicalPart(part: string): string {
  return KRAD_ALIAS.get(part) ?? part
}
